import { AnyAction } from 'redux';
import produce from 'immer';
import { GET_SCHEDULE_REQUEST, GET_SCHEDULE_SUCCESS, GET_SCHEDULE_FAILURE, GET_SCHEDULE_INITIAL } from '../../actions';

// プログラムリスト
type ProgramInfo = {
  programId: string;
  programName: string | null;
  programComment: string;
  selectFlag: number;
};

// スケジュール枠明細情報
export type FrameInfo = {
  startTime: string;
  endTime: string;
  reservationLimitDatetime: string;
  bookedCount: number;
  totalCount: number;
  isDisabled: boolean; // 予約不可フラグ (終了時間過ぎ)
};

// コンテンツ明細情報
export type ContentsInfo = {
  contentsId: string | null;
  contentsName: string | null;
  isAnnex: number;
  cancelWaitNotice: number; // キャンセル待ち通知方式 0：キャンセル待ち不可、1：キャンセル待ち可
  frameList: FrameInfo[];
};

// スケジュール明細情報
type ScheduleInfo = {
  infoDate: string;
  week: string;
  contentsList: ContentsInfo[];
};

type ScheduleType = {
  result: number;
  errorMessage: string | null;
  programList: ProgramInfo[];
  scheduleList: ScheduleInfo[];
};

export type GetScheduleType = {
  isGetScheduleLoading: boolean;
  isGetScheduleLoaded: boolean;
  getSchedule: ScheduleType;
};

const initialState: GetScheduleType = {
  isGetScheduleLoading: false,
  isGetScheduleLoaded: false,
  getSchedule: {
    result: 0,
    errorMessage: null,
    programList: [],
    scheduleList: [],
  },
};

const scheduleGetReducer = (state = initialState, action: AnyAction): GetScheduleType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case GET_SCHEDULE_REQUEST:
        dataState.isGetScheduleLoading = true;
        dataState.isGetScheduleLoaded = false;
        dataState.getSchedule = initialState.getSchedule;
        break;
      case GET_SCHEDULE_SUCCESS: {
        dataState.isGetScheduleLoading = false;
        dataState.isGetScheduleLoaded = true;

        const scheduleData: ScheduleType = action.data;

        // 使用 map 创建新的 scheduleList 并设置 isDisabled 标志
        const updatedScheduleList = scheduleData.scheduleList.map((schedule) => {
          const { infoDate, contentsList } = schedule;
          const safeContentsList = contentsList || [];
          const updatedContentsList = safeContentsList.map((content) => {
            const updatedFrameList = content.frameList.map((frame) => {
              const endTimeStr = `${infoDate.slice(0, 4)}-${infoDate.slice(4, 6)}-${infoDate.slice(
                6,
                8,
              )}T${frame.endTime.slice(0, 2)}:${frame.endTime.slice(2, 4)}:00`;
              const endDate = new Date(endTimeStr);
              if (frame.endTime === '0000') {
                endDate.setDate(endDate.getDate() + 1);
              }
              const startTimeStr = `${frame.reservationLimitDatetime.slice(
                0,
                4,
              )}-${frame.reservationLimitDatetime.slice(4, 6)}-${frame.reservationLimitDatetime.slice(
                6,
                8,
              )}T${frame.reservationLimitDatetime.slice(8, 10)}:${frame.reservationLimitDatetime.slice(10, 12)}:00`;
              const startDate = new Date(startTimeStr);
              const isPast = startDate < new Date() || endDate <= new Date();
              // const isPast = new Date(endTimeStr) < new Date();

              return {
                ...frame,
                isDisabled: isPast,
              };
            });

            return {
              ...content,
              frameList: updatedFrameList,
            };
          });

          return {
            ...schedule,
            contentsList: updatedContentsList,
          };
        });

        dataState.getSchedule = {
          ...scheduleData,
          scheduleList: updatedScheduleList,
        };
        break;
      }
      case GET_SCHEDULE_FAILURE:
        dataState.isGetScheduleLoading = false;
        dataState.isGetScheduleLoaded = false;
        dataState.getSchedule = initialState.getSchedule;
        break;
      case GET_SCHEDULE_INITIAL:
        dataState.isGetScheduleLoading = false;
        dataState.isGetScheduleLoaded = false;
        dataState.getSchedule = initialState.getSchedule;
        break;
      default:
        break;
    }
  });
};

export default scheduleGetReducer;
